<app-breadcrumb [master]="'OCK'" [parentName]="'Import'"  [name]="'NIP '"></app-breadcrumb>
<div class="nip-list-container">

  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="nip-list-filters">
    <mat-form-field class="nip-list-filter">
      <mat-label>NIP</mat-label>
      <input matInput placeholder="NIP" name="contains$nip" [(ngModel)]="initialFilters.contains$nip">
    </mat-form-field>

  </form>

  <div class="nip-list-buttons">
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>
  <table mat-table [dataSource]="row">


    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> NIP </th>
      <td mat-cell *matCellDef="let element">
        {{element.nip}}
      </td>
    </ng-container>


    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>  </th>
      <td mat-cell *matCellDef="let element">
        <button
          mat-button
          (click)="delete(element.uuid)"
          color="warn"><mat-icon>delete</mat-icon></button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>
  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
